const swea = require('swea');
const ImageCatalogueService = swea.react.services.ImageCatalogueService;
const ImageViewerService = swea.react.services.ImageViewerService;
import EventEmitter from 'eventemitter3';
import * as globals from '../globals';

/**
 * The ViewStateManager is responsible for the current 2D/3D state of the app.
 * @class
 */
class ViewStateManager extends EventEmitter {
  /**
   * Static "enum" object for specifying 2D/3D state.
   * @type { object }
   * @static
   */
  static ViewStates = {
    STATE_2D: 0,
    STATE_3D: 1
  };
  
  /**
   * Keeps the singleton instance.
   * @type {ViewStateManager}
   * @static
   * @private
   */
  static _instance = undefined;

  /**
   * Get the singleton manager instance.
   * @return { ViewStateManager } The instance.
   * @public
   */
  static instance() {
    if(ViewStateManager._instance === undefined) {
      ViewStateManager._instance = new ViewStateManager();
    }
    return ViewStateManager._instance;
  }

  /**
   * Initiate the ViewStateManager
   * @constructor
   * @private
   */
  constructor() {
    super();
    
    /**
     * The current 2D/3D state.
     * @type { ViewStateManager.ViewStates }
     * @private
     */
    this._state = (swea.util.getQueryParameters().imagefirst === '1' ? ViewStateManager.ViewStates.STATE_2D : ViewStateManager.ViewStates.STATE_3D);
    this._imageCatalogueState = ImageCatalogueService.instance().getState();
    this._imageViewerState = ImageViewerService.instance().getState();
    this._imageCatalogueListener = ImageCatalogueService.instance().addChangeListener(this._updateCatalogueState);
    this._imageViewerListener = ImageViewerService.instance().addChangeListener(this._updateImageVieweerState);
  }

  /**
   * Returns the current 2D/3D state.
   * @returns { ViewStateManager.ViewStates } The current 2D/3D state.
   */
  getState() {
    return this._state;
  }

  /**
   * When the image catalogue is closed toggle to 3D state.
   */
  _updateCatalogueState = () => {
    this._imageCatalogueState = ImageCatalogueService.instance().getState();
    this._updateState();
  };

  _updateImageVieweerState = () => {
    this._imageViewerState = ImageViewerService.instance().getState();
    this._updateState();
  };

  _updateState = () => {
    if(this._imageCatalogueState.isOpen || this._imageViewerState.isOpen){
      this.setState(this._state = ViewStateManager.ViewStates.STATE_2D);
    } else {
      this.setState(this._state = ViewStateManager.ViewStates.STATE_3D);
    }
  };
    
  /**
   * Sets the 2D/3D state and emits change to listeners.
   * @param { ViewStateManager.ViewStates } state The new 2D/3D state.
   */
  setState(state) {
    this._state = state;
    this.emit(globals.STATE_CHANGED);
  }

  /**
   * Clear the manager.
   * @public
   */
  clear() {
    this._state = ViewStateManager.ViewStates.STATE_2D;
  }

  /**
   * Reset the manager to its original state.
   * @static
   * @public
   */
  static reset() {
    if (ViewStateManager._instance) {
      ViewStateManager._instance.clear();
      ViewStateManager._instance = undefined;
      ImageCatalogueService.instance().removeChangeListener(ViewStateManager._instance._imageCatalogueListener);
      ImageCatalogueService.instance().removeChangeListener(ViewStateManager._instance._imageViewerListener);
    }
  }
}
export default ViewStateManager;
